import { ReactComponent as HorizontalLayoutIcon } from 'assets/icons/input_horizontal_layout_icon.svg';
import { ReactComponent as VerticalLayoutIcon } from 'assets/icons/input_vertical_layout_icon.svg';

export const LABEL_LAYOUT_OPTIONS = [
  { value: 'left', label: 'Horizontal alignment', icon: <HorizontalLayoutIcon /> },
  { value: 'top', label: 'Vertical alignment', icon: <VerticalLayoutIcon /> },
];
